<template>
  <div class="preview" v-if="vmode">
    <component
      v-for="(element) in jsonView"
      :uuid="element.uuid"
      :key="element.uuid"
      :is="element.type"
      :element="element"
      :mode="true"
      :pmode="true"
    ></component>
  </div>
</template>

<script>
export default {
  name: "FormBuilder",
  props: ["mode", "nid", "sid", "json", "pmode"],
  created() {},
  mounted() {
    let titleField = this.$el
      .closest("#webform-builder")
      .querySelector(".field--widget-string-textfield");
    if(titleField) {
      titleField.classList.add("hide");
    }
    let selectTemplates = this.$el
      .closest(".details-wrapper")
      .querySelectorAll("input.form-autocomplete");
    [].forEach.call(selectTemplates, item => {
      this.getData(item);
      item.addEventListener("change", event => {
        var selectElement = event.target;
        if (selectElement.value != "") {
          titleField && titleField.classList.add("hide");
          this.getData(selectElement);
        } else {
          titleField && titleField.classList.remove("hide");
        }
      });
    });
  },
  computed: {
    jsonView() {
      let steps = [];
      let inStep = false;
      if (this.json_data.length > 0) {
        let json = JSON.parse(this.json_data);
        let reorderList = elements => {
          let prevElementType = null;
          let list = [];
          elements.forEach((el, index) => {
            el.list = reorderList(el.list);
            if (el.type == "FbStep" && prevElementType == "FbStep") {
              list[list.length - 1].list.push(el);
            } else if (el.type == "FbStep") {
              list.push({
                type: "FbStepper",
                data: {},
                list: []
              });
              list[list.length - 1].list.push(el);
            } else {
              list.push(el);
            }
            prevElementType = el.type;
          });
          return list;
        };

        return reorderList(json);
      }
      return;
    }
  },
  data() {
    return {
      json_data: {},
      nuuid: this.nid || "",
      suuid: this.sid || "",
      list: [],
      vmode: this.pmode || true
    };
  },
  methods: {
    getData(item) {
      // Get entity ID from autocomplete title value.
      let text = item.value;
      let regex = /\(\d+\)/;
      let match = regex.exec(text);
      let entity_id = match[0]
        .replace('(', '')
        .replace(')', '');
      fetch(
        "/jsonapi/webform_template/webform_template?filter[drupal_internal__id]=" + entity_id
      )
        .then(response => {
          return response.json();
        })
        .then(res => {
          this.json_data = res.data.length ? res.data[0].attributes.template : "";
          this.init(this.json_data);
        });
    },
    init(data) {
      let textarea =
        this.$el.parentElement.parentElement.previousElementSibling.querySelector(
          "textarea"
        ) || document.querySelector("#form_builder_test_json");
      if (data) {
        textarea.value = data;
      }
      if (textarea) {
        let json = textarea.value;
        if (json == "") {
          json = "[]";
        }
        let p_json = JSON.parse(json);
        if (json != "" && p_json) {
          this.list = p_json;
          return;
        }
      }
    }
  },
  watch: {
    list: function(newList) {
      let textarea =
        this.$el.parentElement.parentElement.previousElementSibling.querySelector(
          "textarea"
        ) || document.querySelector("#form_builder_test_json");
      if (!textarea) return;
      textarea.innerHTML = JSON.stringify(newList);
    }
  }
};
</script>
<style lang="scss">
.hide {
  display: none;
}
</style>
